import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-renew-policy',
  templateUrl: './renew-policy.component.html',
  styleUrls: ['./renew-policy.component.css']
})
export class RenewPolicyComponent {
  constructor(
    public dialogRef: MatDialogRef<RenewPolicyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }
  // Note: this renew policy dialog should be called where the renew policy method is implemented

  onDiscardClick(): void {

  this.dialogRef.close(false);
  }



  onSaveClick(): void {
    this.dialogRef.close(true);
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
